import { type SxProps } from '@mui/material'
import { BlockButton } from './BlockButton'

interface Props {
  disabled?: boolean
  startIcon?: JSX.Element
  endIcon?: JSX.Element
  sx?: SxProps
  dataTestId?: string
  children: React.ReactNode
  onClick: () => void
}

export const BlueButton = (props: Props): JSX.Element => {
  return <BlockButton
    disabled={props.disabled}
    startIcon={props.startIcon}
    endIcon={props.endIcon}
    onClick={props.onClick}
    dataTestId={props.dataTestId ?? 'block-button'}
    color='white'
    hover={{
      background: 'linear-gradient(96.34deg, #01142b 0%, var(--blue-700) 100%)',
      color: 'white'
    }}
    sx={{
      ...props.sx,
      background: 'linear-gradient(96.34deg, var(--blue-900) 0%, var(--blue-500) 100%)'
    }}
    disabledSx={{ color: '#dddddd' }}
  >
    {props.children}
  </BlockButton>
}
